<template >
    <b-dropdown>
        <template #button-content>
            <div class="d-flex ddn">
                <img class="bttn" :src="flagpath()" height="25px;" />
                <p style="margin:0;">{{ langName() }}</p>
            </div>
        </template>

        <b-dropdown-item key="az" value="Az" @click="setLang('az')">
            <div class="d-flex">

                <img class="bttn" src="@/assets/az.svg" height="25px;" />
                <p style="margin:0;">Aze</p>
            </div>

        </b-dropdown-item>
        <b-dropdown-item key="en" value="En" @click="setLang('en')">

            <div class="d-flex">

                <img class="bttn" src="@/assets/en.svg" height="25px;" />
                <p style="margin:0;">Eng</p>
            </div>

        </b-dropdown-item>
        <b-dropdown-item key="ru" value="Ru" @click="setLang('ru')">

            <div class="d-flex">

                <img class="bttn" src="@/assets/ru.svg" height="25px;" />
                <p style="margin:0;">Rus</p>
            </div>

        </b-dropdown-item>
    </b-dropdown>
</template>
<script>
import store from '@/store';

export default {
    methods: {

        langName() {
            switch (this.$i18n.locale) {
                case "ru":
                    return "Rus";
                case "az":
                    return "Aze";
                case "en":
                    return "Eng";
                default:
                    break;
            }
        },
        flagpath() {
            return require("../assets/" + this.$i18n.locale + ".svg");
        },
        switchLang() {
            this.$i18n.locale = (this.$i18n.locale == "az") ? "ru" : "az";
        },
        setLang(lang) {
            this.$i18n.locale = lang;
            store.commit('setAppLanguage', lang);
        },
    },
}
</script>
<style lang="css" scoped>
.ddn {
    padding: 27px;
}
</style>